import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import { Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const ModalDialog = (props) => {
  const {title, content, open, handleOk, handleCancel, hideOK, hideCancel, isLoading, maxWidth} = props;
  return (
    <Dialog
      fullWidth
      maxWidth={maxWidth || "sm"}
      open={open}
      onClose={handleCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ px: 3, py: 2 }}>
        <Typography variant="h6" fontWeight={600}>
          {title}
        </Typography>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ px: 3, py: 2.5 }}>
        <DialogContentText id="alert-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ px: 3, py: 1.5, gap: 1 }}>
        {!hideCancel && (
          <Button
            onClick={handleCancel}
            disabled={isLoading}
            color="inherit"
            variant="outlined"
          >
            Cancel
          </Button>
        )}
        {!hideOK && (
          <LoadingButton
            loading={isLoading}
            onClick={handleOk}
            variant="contained"
            autoFocus
          >
            OK
          </LoadingButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ModalDialog;
